export default {
    name: 'v5-icon-star',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M793.6 972.8a25.446 25.446 0 01-12.237-3.123L512 822.784 242.637 969.677a25.549 25.549 0 01-37.479-26.727l49.05-294.195L58.726 453.274a25.651 25.651 0 0113.876-43.367l294.348-49.05 122.164-244.326a25.6 25.6 0 0145.772 0L657.05 360.858l294.348 49.05a25.6 25.6 0 0113.876 43.366L769.792 648.755l49.05 294.195A25.754 25.754 0 01793.6 972.8zM512 768c4.198 0 8.448 1.024 12.237 3.123l235.469 128.41-42.548-255.335a25.446 25.446 0 017.168-22.323L893.952 452.25l-258.15-43.008a25.6 25.6 0 01-18.688-13.824L512 185.19 406.886 395.418a25.754 25.754 0 01-18.688 13.824l-258.15 43.008 169.626 169.625a25.702 25.702 0 017.168 22.323l-42.548 255.335 235.47-128.41A25.446 25.446 0 01512 768z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
